import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setCreditPrompt } from "@/lib/api";
import { Coin, fmtK } from "@/lib/points";

export default function CreditPrompt() {
  const nav = useNavigate();
  const [st, setSt] = useState(null);
  const [renew, setRenew] = useState(true);
  useEffect(() => {
    setCreditPrompt((d) => new Promise((resolve) => { setRenew(true); setSt({ d, resolve }); }));
    return () => setCreditPrompt(null);
  }, []);
  if (!st) return null;
  const { d, resolve } = st;
  const close = (r) => { setSt(null); resolve(r); };
  const short = d.code === "insufficient";
  const timed = (d.items || []).some((i) => i.days);
  return (
    <div className="fixed inset-0 z-[9999] bg-black/50 flex items-end sm:items-center justify-center p-3" data-testid="credit-prompt">
      <div className="bg-white rounded-3xl w-full max-w-sm p-5 gs-fade">
        <div className="flex items-center gap-3"><Coin size={48} /><div className="font-extrabold text-lg text-slate-900">GjejKredit</div></div>
        {short && <div className="mt-3 rounded-2xl bg-rose-50 border border-rose-200 p-3 text-rose-700 text-sm font-semibold" data-testid="credit-short">🔴 Nuk keni GjejKredit të mjaftueshme.<br />Ju duhen edhe {fmtK(d.need)} kredite.</div>}
        <div className="mt-3 space-y-1.5">
          {(d.items || []).map((i) => (
            <div key={i.key} className="flex justify-between text-sm"><span className="text-slate-700">{i.label}{i.days ? ` · ${i.days} ditë` : ""}</span><b className="text-amber-600">{fmtK(i.price)} kredite</b></div>
          ))}
          <div className="flex justify-between text-sm border-t border-slate-100 pt-1.5"><span className="font-bold">Gjithsej</span><b data-testid="credit-total">{fmtK(d.total)} kredite</b></div>
          <div className="flex justify-between text-xs text-slate-500"><span>Ke</span><span data-testid="credit-balance">{fmtK(d.balance)} kredite</span></div>
        </div>
        {!short && timed && (
          <label className="flex items-center gap-2 mt-3 text-sm text-slate-700"><input data-testid="credit-renew" type="checkbox" checked={renew} onChange={(e) => setRenew(e.target.checked)} className="w-4 h-4 accent-emerald-600" />Vazhdo automatikisht kur të skadojë</label>
        )}
        {short && <p className="text-xs text-slate-500 mt-2">Pjesët falas mund t'i publikosh normalisht: hiq opsionet me pagesë ose bli GjejKredit.</p>}
        <div className="flex gap-2 mt-4">
          {short
            ? <button data-testid="credit-buy" onClick={() => { close({ ok: false }); nav("/gjejkredit/bli"); }} className="flex-1 h-11 rounded-xl bg-amber-500 text-white font-bold">Bli GjejKredit</button>
            : <button data-testid="credit-confirm" onClick={() => close({ ok: true, renew })} className="flex-1 h-11 rounded-xl bg-emerald-500 text-white font-bold">Paguaj {fmtK(d.total)} kredite</button>}
          <button data-testid="credit-cancel" onClick={() => close({ ok: false })} className="h-11 px-4 rounded-xl bg-slate-100 text-slate-700 font-semibold">Anulo</button>
        </div>
      </div>
    </div>
  );
}
